import { api } from '@/api'
import type { ApiPaginationResponse, ApiResponse } from '@/api/typings/response.typing'
import type { TransferMethodItem } from '@/api/typings/settings.typing'

export function getTransferMethodsAction(page: number = 1): Promise<ApiPaginationResponse<TransferMethodItem[]>> {
  return api.v2.get<ApiPaginationResponse<TransferMethodItem[]>>(`/transfer-methods?page=${page}`)
}
export function createTransferMethodAction(payload: {
  title: string
  label: string
  status: string
}): Promise<ApiResponse<TransferMethodItem>> {
  return api.v2.post<ApiResponse<TransferMethodItem>>(`/transfer-methods`, { ...payload })
}

export function updateTransferMethodAction(
  id: string,
  payload: {
    title: string
    label: string
    status: string
  }
): Promise<ApiResponse<TransferMethodItem>> {
  return api.v2.put<ApiResponse<TransferMethodItem>>(`/transfer-methods/${id}`, { ...payload })
}

export function toggleTransferMethodActivationAction(
  id: string,
  payload: {
    activation: boolean
  }
): Promise<ApiResponse<TransferMethodItem>> {
  return api.v2.patch<ApiResponse<TransferMethodItem>>(`/transfer-methods/${id}/toggle-activation`, { ...payload })
}
